import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 gap-4 lg:grid-cols-[1fr_280px]" }
const _hoisted_2 = { class: "rounded-2xl border-t-4 border-teal-500 bg-white p-4 shadow-sm ring-1 ring-gray-200" }
const _hoisted_3 = { class: "flex items-start gap-3" }
const _hoisted_4 = { class: "flex size-10 shrink-0 items-center justify-center rounded-xl bg-teal-50 text-teal-700" }
const _hoisted_5 = { class: "min-w-0 flex-1" }
const _hoisted_6 = { class: "font-semibold text-gray-900" }
const _hoisted_7 = { class: "mt-0.5 text-xs text-gray-500" }
const _hoisted_8 = { class: "sr-only" }
const _hoisted_9 = { class: "mt-3 rounded-xl border border-gray-200 bg-gray-50 p-3 text-sm leading-relaxed text-gray-700" }
const _hoisted_10 = { class: "font-semibold text-teal-700" }
const _hoisted_11 = { class: "mt-3 flex flex-wrap gap-2" }
const _hoisted_12 = { class: "mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2" }
const _hoisted_13 = { class: "rounded-2xl bg-white p-4 shadow-sm ring-1 ring-gray-200" }
const _hoisted_14 = { class: "flex items-start gap-3" }
const _hoisted_15 = { class: "flex size-10 shrink-0 items-center justify-center rounded-xl bg-gray-100 text-gray-500" }
const _hoisted_16 = { class: "min-w-0" }
const _hoisted_17 = { class: "font-semibold text-gray-900" }
const _hoisted_18 = { class: "ml-1 rounded-full bg-gray-100 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-gray-500" }
const _hoisted_19 = { class: "mt-0.5 text-xs text-gray-500" }
const _hoisted_20 = { class: "rounded-2xl bg-white p-4 shadow-sm ring-1 ring-gray-200" }
const _hoisted_21 = { class: "flex items-start gap-3" }
const _hoisted_22 = { class: "flex size-10 shrink-0 items-center justify-center rounded-xl bg-gray-100 text-gray-500" }
const _hoisted_23 = { class: "min-w-0" }
const _hoisted_24 = { class: "font-semibold text-gray-900" }
const _hoisted_25 = { class: "ml-1 rounded-full bg-gray-100 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-gray-500" }
const _hoisted_26 = { class: "mt-0.5 text-xs text-gray-500" }
const _hoisted_27 = { class: "order-first flex flex-col items-center gap-2 lg:order-none" }
const _hoisted_28 = { class: "text-[10px] font-bold uppercase tracking-wide text-gray-400" }
const _hoisted_29 = { class: "w-full max-w-[240px] overflow-hidden rounded-3xl border-[6px] border-gray-900 bg-white shadow-lg" }
const _hoisted_30 = { class: "bg-gradient-to-br from-teal-400 to-teal-700 px-3 py-3 text-center text-xs font-semibold text-white" }
const _hoisted_31 = { class: "flex border-b border-gray-200 text-[11px] font-semibold" }
const _hoisted_32 = { class: "flex-1 border-b-2 border-teal-600 py-2 text-center text-teal-700" }
const _hoisted_33 = { class: "flex-1 py-2 text-center text-gray-400" }
const _hoisted_34 = { class: "space-y-2 p-3" }
const _hoisted_35 = { class: "text-[11px] leading-snug text-gray-700" }
const _hoisted_36 = { class: "text-[9px] font-bold uppercase tracking-wide text-gray-400" }
const _hoisted_37 = { class: "mt-1 rounded-lg bg-teal-600 py-2 text-center text-[11px] font-semibold text-white" }

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { Switch } from '@headlessui/vue';
import {
  PaperAirplaneIcon,
  ChatBubbleLeftRightIcon,
  TableCellsIcon,
  CheckIcon,
} from '@heroicons/vue/24/outline';
import useAuthStore from '@/store/auth';
import useLivviaStore from '@/store/livvia';


export default /*@__PURE__*/_defineComponent({
  __name: 'PrepareCards',
  setup(__props) {

const { t } = useI18n();
const { session } = useAuthStore();
const livvia = useLivviaStore();

const shortHandle = computed(() => {
  const name = session?.name?.split(' ')[0] || 'voce';
  return name.toLowerCase().replace(/[^a-z0-9]/g, '');
});

const chips = computed(() => [
  t('livvia.prepare.messageCard.chips.name'),
  t('livvia.prepare.messageCard.chips.whatsapp'),
  t('livvia.prepare.messageCard.chips.cpf'),
  t('livvia.prepare.messageCard.chips.address'),
]);

const phoneFields = computed(() => [
  t('livvia.prepare.phone.fieldName'),
  t('livvia.prepare.phone.fieldWhatsapp'),
  t('livvia.prepare.phone.fieldCpf'),
  t('livvia.prepare.phone.fieldAddress'),
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, [
            _createVNode(_unref(PaperAirplaneIcon), { class: "size-5" })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(t)('livvia.prepare.messageCard.title')), 1),
            _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(t)('livvia.prepare.messageCard.description')), 1)
          ]),
          _createVNode(_unref(Switch), {
            modelValue: _unref(livvia).autoMessageEnabled,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(livvia).autoMessageEnabled) = $event)),
            class: _normalizeClass([_unref(livvia).autoMessageEnabled ? 'bg-teal-600' : 'bg-gray-300', 'relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-600'])
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)('livvia.prepare.messageCard.toggle')), 1),
              _createElementVNode("span", {
                "aria-hidden": "true",
                class: _normalizeClass([_unref(livvia).autoMessageEnabled ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none inline-block size-5 transform rounded-full bg-white shadow-sm ring-0 transition duration-200 ease-in-out'])
              }, null, 2)
            ]),
            _: 1
          }, 8, ["modelValue", "class"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createTextVNode(_toDisplayString(_unref(t)('livvia.prepare.messageCard.preview')) + " ", 1),
          _createElementVNode("span", _hoisted_10, "livelink.com.br/r/" + _toDisplayString(shortHandle.value), 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chips.value, (chip) => {
            return (_openBlock(), _createElementBlock("span", {
              key: chip,
              class: "inline-flex items-center gap-1 rounded-full border border-teal-100 bg-teal-50 px-3 py-1 text-xs font-semibold text-teal-700"
            }, [
              _createVNode(_unref(CheckIcon), { class: "size-3" }),
              _createTextVNode(" " + _toDisplayString(chip), 1)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("span", _hoisted_15, [
              _createVNode(_unref(ChatBubbleLeftRightIcon), { class: "size-5" })
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("p", _hoisted_17, [
                _createTextVNode(_toDisplayString(_unref(t)('livvia.prepare.autoReplies.title')) + " ", 1),
                _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(t)('livvia.prepare.optional')), 1)
              ]),
              _createElementVNode("p", _hoisted_19, _toDisplayString(_unref(t)('livvia.prepare.autoReplies.description')), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("span", _hoisted_22, [
              _createVNode(_unref(TableCellsIcon), { class: "size-5" })
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("p", _hoisted_24, [
                _createTextVNode(_toDisplayString(_unref(t)('livvia.prepare.products.title')) + " ", 1),
                _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(t)('livvia.prepare.optional')), 1)
              ]),
              _createElementVNode("p", _hoisted_26, _toDisplayString(_unref(t)('livvia.prepare.products.description')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("p", _hoisted_28, _toDisplayString(_unref(t)('livvia.prepare.phone.note')), 1),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(t)('livvia.prepare.phone.header', { handle: shortHandle.value })), 1),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("span", _hoisted_32, _toDisplayString(_unref(t)('livvia.prepare.phone.tabData')), 1),
          _createElementVNode("span", _hoisted_33, _toDisplayString(_unref(t)('livvia.prepare.phone.tabCart')), 1)
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("p", _hoisted_35, _toDisplayString(_unref(t)('livvia.prepare.phone.greeting')), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(phoneFields.value, (f) => {
            return (_openBlock(), _createElementBlock("div", { key: f }, [
              _createElementVNode("p", _hoisted_36, _toDisplayString(f), 1),
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "mt-1 h-6 rounded-md border border-gray-200 bg-gray-50" }, null, -1))
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_37, _toDisplayString(_unref(t)('livvia.prepare.phone.btn')), 1)
        ])
      ])
    ])
  ]))
}
}

})